<!-- <div class="form-item" >
                    <ng-container *ngIf="address_fields.indexOf('location') > -1">
                        
                           
                                
                                    <ion-label>{{"location" | translate}}</ion-label>
                                
                                    <div class="form-inner">
                                    <ion-input area-label='{{"location" | translate}}' type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="location"
                                        placeholder='{{"location" | translate}}'>
                                    </ion-input>
                                </div>
                           
                        
                    </ng-container>
                </div> -->
<!-- <div class="headmodal">
    <div class="titlemodal">
        {{"address" | translate}}
    </div>
    <ion-button class="close-button" (click)="closeModal()">
        <ion-icon color="primary" name="close-outline"></ion-icon>
    </ion-button>
</div> -->

<div class="addressCard bg-light noScrollBar" id="addressFormContainer">
    <ng-container *ngIf="address;else loadSkeleton">
        <div class="form-card bg-light" id="addressForm">
            <!-- <ion-label>{{"address_info" | translate}}</ion-label> -->

            <div class="form-item-h">
                <div class="form-item addname">
                    <ng-container *ngIf="address_fields.indexOf('address_name') > -1">
                        <app-input [inputId]="'addressNameInput'" [inputLabel]="'name' | translate" [placeholder]="'name' | translate" [type]="'text'" [(ngModel)]="addressForm.name" [ngModelOptions]="{standalone: true}"
                            [controlName]="'name'" name="name">
                        </app-input>
                    </ng-container>
                </div>
                <div class="form-item number">
                    <ng-container *ngIf="address_fields.indexOf('phone') > -1">
                        <app-input [inputId]="'addressPhoneInput'" [inputLabel]="'delivery_contact' | translate" [placeholder]="'delivery_contact' | translate" [type]="'tel'" [(ngModel)]="addressForm.phone"
                            [ngModelOptions]="{standalone: true}" [controlName]="'phone'" name="phone">
                        </app-input>
                    </ng-container>
                </div>
            </div>



            <div class="form-item">
                <app-input [inputId]="'addressAreaInput'" [inputLabel]="'area' | translate" [placeholder]="'Select your area' | translate" [type]="'area-modal'" [(ngModel)]="addressForm.area_id"
                    [ngModelOptions]="{standalone: true}" [controlName]="'area_id'" name="areasOrRegionId" [displayValue]="addressForm.area" (modalOpenRequest)="openAreaModal()"
                    [showDropdownArrow]="true"></app-input>
            </div>

            <div class="form-item">
                <app-input [inputId]="'addressSlotInput'" [inputLabel]="'slot' | translate" [placeholder]="'Select a delivery slot' | translate" [type]="'select'" [(ngModel)]="addressForm.areaSlotId"
                    [ngModelOptions]="{standalone: true}" [controlName]="'areaSlotId'" name="areaSlotId" [selectOptions]="areaSlots" [showDropdownArrow]="false"></app-input>
            </div>

            <div class="form-item-h">
                <div class="form-item block">
                    <ng-container *ngIf="address_fields.indexOf('block') > -1">
                        <app-input [inputId]="'addressBlockInput'" [inputLabel]="'block' | translate" [placeholder]="'block' | translate" [type]="'text'" [(ngModel)]="addressForm.block" [ngModelOptions]="{standalone: true}"
                            [controlName]="'block'" name="block">
                        </app-input>
                    </ng-container>
                </div>
                <div class="form-item avenue">
                    <ng-container *ngIf="address_fields.indexOf('avenue') > -1">
                        <app-input [inputId]="'addressAvenueInput'" [inputLabel]="'avenue' | translate" [placeholder]="'avenue' | translate" [type]="'text'" [(ngModel)]="addressForm.avenue" [ngModelOptions]="{standalone: true}"
                            [controlName]="'avenue'" name="avenue">
                        </app-input>
                    </ng-container>
                </div>
            </div>
            <div class="form-item-h">

                <div class="form-item street">
                    <ng-container *ngIf="address_fields.indexOf('street') > -1">
                        <app-input [inputId]="'addressStreetInput'" [inputLabel]="'street' | translate" [placeholder]="'street' | translate" [type]="'text'" [(ngModel)]="addressForm.street" [ngModelOptions]="{standalone: true}"
                            [controlName]="'street'" name="street">
                        </app-input>
                    </ng-container>
                </div>

                <div class="form-item bldg">
                    <ng-container *ngIf="address_fields.indexOf('house_name') > -1">
                        <app-input [inputId]="'addressHouseInput'" [inputLabel]="'house_building_number' | translate" [placeholder]="'house_building_number' | translate" [type]="'text'" [(ngModel)]="addressForm.house_name"
                            [ngModelOptions]="{standalone: true}" [controlName]="'house_name'" name="house_name">
                        </app-input>
                    </ng-container>
                </div>
            </div>
            <div class="form-item-h">

                <div class="form-item floor">
                    <ng-container *ngIf="address_fields.indexOf('floor') > -1">
                        <app-input [inputId]="'addressFloorInput'" [inputLabel]="'floor' | translate" [placeholder]="'floor' | translate" [type]="'text'" [(ngModel)]="addressForm.floor" [ngModelOptions]="{standalone: true}"
                            [controlName]="'floor'" name="floor">
                        </app-input>
                    </ng-container>
                </div>
                <div class="form-item flat">
                    <ng-container *ngIf="address_fields.indexOf('flat') > -1">
                        <app-input [inputId]="'addressFlatInput'" [inputLabel]="'flatNo' | translate" [placeholder]="'flatNo' | translate" [type]="'text'" [(ngModel)]="addressForm.flat" [ngModelOptions]="{standalone: true}"
                            [controlName]="'flat'" name="flat">
                        </app-input>
                    </ng-container>
                </div>
            </div>

       

            <div class="form-item landmark">
                <ng-container *ngIf="address_fields.indexOf('landmark') > -1">
                    <app-input [inputId]="'addressLandmarkInput'" [inputLabel]="'landmark' | translate" [placeholder]="'landmark' | translate" [type]="'text'" [(ngModel)]="addressForm.landmark" [ngModelOptions]="{standalone: true}"
                        [controlName]="'landmark'" name="landmark">
                    </app-input>
                </ng-container>
            </div>
<div class="form-item-h">
            <div class="form-item zip">
                <ng-container *ngIf="address_fields.indexOf('zip_code') > -1">
                    <app-input [inputId]="'addressZipInput'" [inputLabel]="'zip_code' | translate" [placeholder]="'zip_code' | translate" [type]="'text'" [(ngModel)]="addressForm.zip_code" [ngModelOptions]="{standalone: true}"
                        [controlName]="'zip_code'" name="zip_code">
                    </app-input>
                </ng-container>
            </div>

                 <div class="form-item paci">
                <ng-container *ngIf="address_fields.indexOf('PACI_number') > -1">
                    <app-input [inputId]="'addressPaciInput'" [inputLabel]="'PACI_number' | translate" [placeholder]="'PACI_number' | translate" [type]="'text'" [(ngModel)]="addressForm.PACI_number"
                        [ngModelOptions]="{standalone: true}" [controlName]="'PACI_number'" name="PACI_number">
                    </app-input>
                </ng-container>
            </div>
</div>
            <div class="form-item dnote">
                <ng-container *ngIf="address_fields.indexOf('driver_note') > -1">
                    <app-input [inputId]="'addressDriverNoteInput'" [inputLabel]="'driver_note' | translate" [placeholder]="'driver_note' | translate" [type]="'text'" [(ngModel)]="addressForm.driver_note"
                        [ngModelOptions]="{standalone: true}" [controlName]="'driver_note'" name="driver_note">
                    </app-input>
                </ng-container>
            </div>

            <div class="form-item note">
                <ng-container *ngIf="address_fields.indexOf('notes') > -1">
                    <app-input [inputId]="'addressNotesInput'" [inputLabel]="'notes' | translate" [placeholder]="'notes' | translate" [type]="'textarea'" [additionalClasses]="'textarea'" [(ngModel)]="addressForm.notes" [ngModelOptions]="{standalone: true}"
                        [controlName]="'notes'" name="notes">
                    </app-input>
                </ng-container>
            </div>

        </div>
        <div class="form-footer">
            <app-button class="newPost" (buttonClick)="onSubmitAddress()" color="primary" [width]="'50'" [height]="'8'">
                <!-- <div class="inData"> -->
                <ion-icon src="'../../../../../assets/svg/arrowh.svg" class="inIcon"></ion-icon>
                {{'submit' | translate}}
                <!-- </div> -->
            </app-button>
        </div>
    </ng-container>
    <ng-template #loadSkeleton>
     <div class="loader"></div>
    </ng-template>
</div>